export const API_END_POINTS = {
  /**
   * @ Auth Service
   */
  signIn: "/api/auth/sign-in",
  signUp: "/api/auth/sign-up",
  reset: "/api/auth/reset-password",
  addCustomer: "/api/auth/signup",

  /**
   * @ Tenant Auth service
   */
  generateOtp: "/tenantauth/api/tenantauth/generateOTP",
  verifyOtp: "/tenantauth/api/tenantauth/verifyOTP",
  updatePassword: "/tenantauth/api/tenantauth/updatePassword",
  verifyPassword: "/tenantauth/api/tenantauth/verifyPassword",

  /**
   * @ User Profile
   */
  getAllCustomers: "/api/userprofile/users/allCustomers",
  getCustomersPaginated: "/api/userprofile/users/userpaginate",
  addNewAddress: "/api/userprofile/users/newaddress",
  editAddress: "/api/userprofile/users/editaddress",

  /**
   * @ DigitShelf
   */
  getAllDigitshelf: "/master/api/shelf/getShelfTypes",
  addDigitshelf: "/master/api/shelf/create",
  updateDigitshelf: "/master/api/shelf/update",
  deleteDigitshelf: "/master/api/shelf/delete",
  deleteManyDigitshelf: "/master/api/shelf/deletemany",
  getdigitShelfDetails: "/smart/api/smartshelf/getdigitshelfdetails",

  /**
   * @ Gender
   */
  getAllGender: "/master/api/gender/getGender",
  getGender: "/master/api/gender",
  addGender: "/master/api/gender/create",
  updateGender: "/master/api/gender/update",
  deleteGender: "/master/api/gender/delete",
  deleteManyGender: "/master/api/gender/deletemany",

  /**
   * @ UOM
   */
  getAllMeasure: "/master/api/measurement/getuom",
  addMeasure: "/master/api/measurement/create",
  updateMeasure: "/master/api/measurement/update",
  deleteMeasure: "/api/measurement/delete",
  deleteManyMeasure: "/master/api/measurement/deletemany",

  /**
   * @ Barocde
   */
  getAllBarcodeTypes: "/master/api/barcode/getbarcodes",
  addBarcodeTypes: "/master/api/barcode/create",
  updateBarcodeTypes: "/master/api/barcode/update",
  deleteBarcodeTypes: "/api/barcode/delete",
  deleteManyBarcodeTypes: "/master/api/barcode/deletemany",

  /**
   * @ STORE_TYPE
   */
  getAllStoreTypes: "/master/api/store/getStoreTypes",
  addStoreTypes: "/master/api/store/create",
  updateStoreTypes: "/master/api/store/update",
  deleteStoreTypes: "/api/store/delete",
  deleteManyStoreTypes: "/master/api/store/deletemany",

  /**
   * @ STORE_TYPE
   */
  getCoolerAPICoolerHealth: "/gondola/api/devices",
  /**
   * @ Tax code
   */
  getTaxCodes: "/master/api/taxs/getTaxCodes",
  getEntityUseCodes: "/master/api/taxs/getEntityUseCodes",
  getTaxTypes: "/master/api/taxs/getTaxTypes",
  getTaxForTaxProvider: "/master/api/taxs/getTaxForTaxProvider",

  /**
   * @ Location service
   */
  getlocationtypes: "/master/api/location/getlocationtypes",
  getlocationservices: "/master/api/location/getlocationservices",
  getTimezoneByCountry: "/master/api/timezone/getTimezoneByCountry",
  getPDFUploadLocationProductMapping:
    "/masterdata/api/masterdata/location/product/mapping/import",
  getPDFUploadLocationProductMappingSkipError:
    "/masterdata/api/masterdata/location/product/mapping/getBulkUploadProductMappingStatus",
  getPDFUploadLocationProductMappingLiveSocket:
    "/progressws/ws/product-mapping-status",
  checkPurchaseFile:
    "/masterdata/api/masterdata/location/product/mapping/check/purchaseFile",
  previewInvoice:
    "/masterdata/api/masterdata/location/product/mapping/previewInvoice",
  uploadInvoiceData:
    "/masterdata/api/masterdata/location/product/mapping/upload/invoice/data",
  purchaseCheckProcess: "/masterdata/api/masterdata/purchase/check/process",
  purchaseCheckFileName: "/masterdata/api/masterdata/purchase/check/fileName",
  purchaseUploadInvoice: "/masterdata/api/masterdata/purchase/uploadInvoice",
  purchaseCreateProducts: "/masterdata/api/masterdata/purchase/create/products",
  purchaseCreateProductMappings:
    "/masterdata/api/masterdata/purchase/create/productMappings",
  purchaseUpdateInventory: "/masterdata/api/masterdata/purchase/update/inventory",
  purchaseUpdateProductMappings:
    "/masterdata/api/masterdata/purchase/update/productMappings",
  purchaseCurrentData: "/masterdata/api/masterdata/purchase/currentPurchaseData",
  purchaseCancel: "/masterdata/api/masterdata/purchase/cancelPurchaseRecord",
  purchaseInvoiceHistory:
    "/masterdata/api/masterdata/purchase/invoice/history",
  purchaseInvoiceHistoryDetails:
    "/masterdata/api/masterdata/purchase/invoice/history/details",
  importInvalidRecords:
    "/masterdata/api/masterdata/location/product/mapping/import/invalidRecords",
  archiveProductMappingStatus:
    "/masterdata/api/masterdata/location/product/mapping/archiveProductMappingStatus",

  /**
   * @ Country
   */
  getAllCountries: "/master/api/countries/getCountries",
  addCountry: "/api/countries/create",
  updateCountry: "/api/countries/update",
  deleteCountry: "/api/countries/delete",
  deleteManyCountry: "/api/countries/deletemany",
  getCountriesAndCurrency: "/master/api/countries/getCountriesAndCurrency",
  getStateByCountry: "/master/api/state/getstatebycountryid",

  /**
   * @ Currency
   */
  getAllCurrencies: "/api/currency/getcurrency",
  addCurrency: "/api/currency/create",
  updateCurrency: "/api/currency/update",
  deleteCurrency: "/api/currency/delete",
  deleteManyCurrency: "/api/currency/deletemany",

  /**
   * @ Province
   */
  getAllProvinces: "/api/province",
  addProvinces: "/api/province/create",
  updateProvinces: "/api/province/update",
  deleteProvinces: "/api/province/delete",
  deleteManyProvinces: "/api/province/deletemany",

  /**
   * @ State
   */
  getAllState: "/master/api/state/states",
  addState: "/api/state/create",
  updateState: "/api/state/update",
  deleteState: "/api/state/delete",
  deleteManyState: "/api/state/deletemany",

  /**
   * @ Language
   */
  getAllLanguage: "/api/language/fetchLanguages",
  addLanguage: "/api/language/create",
  updateLanguage: "/api/language/update",
  deleteLanguage: "/api/language/delete",
  deleteManyLanguage: "/api/language/deletemany",

  /**
   * @ Package Types
   */
  getpackagingtypes: "/master/api/packaging/getpackagingtypes",

  /**
   * @ Princes
   */
  getAllPrices: "/api/prices",
  getAnPrice: "/api/prices/price",
  updateAnPrice: "/api/prices/update",
  createPrice: "/api/prices/create",
  deletePrice: "/api/prices/delete",
  priceLocationElasticSearch: "/api/searchprice/locations?searchTerm=",

  /**
   * @ Stores service
   */
  getAllCities: "/store/api/stores/getAllCities",
  getAllStates: "/store/api/stores/getAllRegions",
  addLocation: "/store/api/stores/create",
  getAllStores: "/store/api/stores/getlocations",
  getLocation: "/store/api/stores/location",
  getAnStore: "/store/api/stores/store",
  getLocationGroup: "/store/api/stores/locationgroup",
  deleteAnStore: "/store/api/stores/delete",
  deleteManyStore: "/store/api/stores/deletemany",
  getGroupById: "/store/api/stores/getGroupById",
  updateGroup: "/store/api/stores/updateGroup",
  createLocationGroup: "/store/api/stores/createlocationgroup",
  deleteStoreGroup: "/store/api/stores/deleteGroupStore",
  checkLocationExist: "/store/api/stores/checkLocationExist",
  updateLocation: "/store/api/stores/updateLocation",
  updateLocationGroup: "/store/api/stores/updatelocationgroup",
  getlocationgroups: "/store/store/api/stores/getlocationgroups",
  getLocationByGroupId: "/store/api/stores/getLocationByGroupId",
  getDashBoardStore: "/store/api/stores/getStoresforDashboard",
  getLocationSecretFromKV: "/store/api/stores/getLocationSecretFromKV",
  updateLocationSecretInKV: "/store/api/stores/updateLocationSecretInKV",
  validateAddress: "/address/api/address/validateAddress",

  /**
   * @ Product service
   */
  getAllBrands: "/product/api/products/getAllBrands",
  getAllManufacturers: "/product/api/products/getAllManufacturers",
  createProduct: "/product/api/products/create",
  UploadProductImage: "/product/api/products/upload",
  getAllProducts: "/product/api/products/geteveryproducts",
  getProductPaginated: "/product/api/products/productpaginate",
  getproductbygroupId: "/product/api/products/getproductbygroupId",
  getProductGroup: "/product/api/products/productgroup",
  updateproductgroup: "/product/api/products/updateproductgroup",
  createproductgroup: "/product/api/products/createproductgroup",
  deleteManyAttributes: "/product/api/products/deleteProductAttributes",
  bulkUploadProducts: "/product/api/products/bulkUploadProducts",
  getProductMappingDetails: "/product/api/products/getProductMapping",

  exportAllProductMappings: "/product/api/products/exportAllProductMappings",
  bulkUploadLocationProductMappings:
    "/product/api/products/bulkUploadLocationProductMappings",
  updateProductMappingDetails: "/product/api/products/updateProductMapping",
  createProductMappingDetails: "/product/api/products/createProductMapping",
  deleteProductMappings: "/product/api/products/deleteProductMappings",
  getAllProductItemIdList: "/product/api/products/getAllProductItemIdList",
  getunmappedProductsOnLocation:
    "/product/api/products/getunmappedProductsOnLocation",
  getUnMappedProductsByStorageUnitId:
    "/product/api/products/getUnMappedProductsByStorageUnitId",
  getProductMappingCount: "/product/api/products/getProductMappingCount",
  getProductMappingSnapShot: "/product/api/products/getProductMappingSnapShot",
  getProductList: "/product/api/products/getProducts",
  getProductMappingSnapShotWSS: "/progressws/ws/productMappingLive",
  tenantDashboard: "/progressws/ws/tenantDashboard",
  storeDashboard: "/progressws/ws/storeDashboard",
  /**
   * @ Location storage
   */
  createStorageUnit: "/product/api/storages/createstorageunit",
  getStorageUnits: "/product/api/storages/getStorageUnits",
  getUnMappedStorageUnits: "/product/api/storages/getUnMappedStorageUnits",
  getSurvillenceCameraList: "/sdc/devices/api/sdc/getsurveillancecameramodels",
  getStorageUnitById: "/product/api/storages/getStorageUnitById",
  updateStorageUnit: "/product/api/storages/updatestorageunit",
  createStorageUnitMapping: "/product/api/storages/createStorageUnitMapping",
  getStorageUnitMappings: "/product/api/storages/getStorageUnitMappings",
  updateStorageUnitMapping: "/product/api/storages/updateStorageUnitMapping",
  createStorageUnitMappingWithAdjustment:
    "/product/api/storages/createStorageUnitMappingWithAdjustment",
  deleteStorageUnitMappings: "/product/api/storages/deleteStorageUnitMappings",
  deleteStorageUnits: "/product/api/storages/deleteStorageUnits",
  bulkUploadStorageProductMappings:
    "/product/api/storages/bulkUploadStorageProductMappings",
  updateCompanyonStorageUnitMapping:
    "/product/api/storages/updateCompanyonStorageUnitMapping",
  getStorageUnitProductMappingCount:
    "/product/api/storages/getStorageUnitProductMappingCount",

  /**
   * @ Customer
   */
  getAllCustomerList: "/api/customer/getcustomers",
  customerInfoValidationCheck: "/api/customer/customerInfoValidation",
  getSocialProfile: "/api/customer/getsocialprofiles",
  getEthnicity: "/api/customer/getethnicity",
  getcustomeracquisitionsource: "/api/customer/getcustomeracquisitionsource",
  deleteCustomers: "/api/customer/deletecustomers",
  createCustomer: "/api/customer/createcustomer",
  getAnCustomer: "/api/customer/getcustomerbyid",
  updateAnCustomer: "/api/customer/updatecustomer",

  /**
   * @ Tansaction
   */
  getTransaction: "/transaction/api/transaction/searchTransactions",
  getInvoiceTransactions: "/transaction/api/transaction/invoiceTransactions",
  getSummaryTransactions: "/transaction/api/transaction/storeInvoiceSummary",
  getCountStatusGroup:
    "/hil/transaction/api/transaction/ui/count/by/status_groups",
  getTransactionAll: "/hil/transaction/api/transaction/ui/all",
  transactionBrowserWSS: "/websocket/api/transaction/ws",
  getStatusGroup:
    "/hil/transaction/api/transaction/ui/status/by/status_group?status_group=",
  getTransactionDetails: "/hil/transaction/api/transaction/ui/by/id",
  createNote: "/hil/transaction/api/transaction/ui/note/add/for/",
  updateCartItemTransaction:
    "/hil/transaction/api/transaction/ui/cart/item/update/for/",
  excludeBarCode:
    "/hil/transaction/api/transaction/ui/products/from/store/exclude/barcodes/by/transaction/",
  updateTransactionStatus:
    "/hil/transaction/api/transaction/ui/status/update/for/",
  updateDisputeStatus: "/hil/api/transaction/ui/dispute/status/update/for/",
  createDispute: "/hil/transaction/api/transaction/ui/create/dispute/",
  disputeReasonsList: "/hil/transaction/api/transaction/ui/dispute/reasons",
  initiateTransactionRefund:
    "/hil/api/transaction/ui/dispute/refund/initiate/for/",
  hitlpendingTransactionStruck:
    "/hil/api/transaction/ui/update/struck/transaction/",
  initiateTransactionChargeback:
    "/hil/api/transaction/ui/dispute/chargeback/initiate/for/",
  declineTransactionDispute: "/hil/api/transaction/ui/dispute/decline/for/",
  initiateTransactionChargebackManual:
    "/hil/transaction/api/transaction/ui/dispute/refund/manual/for",
  initiateTransactionRefundManual:
    "/hil/transaction/api/transaction/ui/dispute/chargeback/manual/for/",
  /**
   * @ Inventory
   */
  getAllInventory: "/api/inventory/getinventories",
  deleteInventories: "/api/inventory/deletemany",
  getInventoryPaginated: "/api/inventory/inventorypaginate",
  createInventory: "/api/inventory/create",
  updateInventory: "/api/inventory/update",
  getParticularInventory: "/api/inventory/getInventoryById",

  getProductAdjustmentHistories:
    "/product/api/products/getProductAdjustmentHistories",
  getStorageAdjustmentHistories:
    "/product/api/storages/getStorageAdjustmentHistories",
  getProductMappingDetail: "/product/api/products/getProductMappingDetail",
  getStorageMappingDetail: "/product/api/storages/getStorageMappingDetail",
  getProductAdjustments: "/product/api/products/getProductAdjustments",

  getStorageAdjustments: "/product/api/storages/getStorageAdjustments",
  createProductAdjustment: "/product/api/products/createProductAdjustment",
  createStorageAdjustment: "/product/api/storages/createStorageAdjustment",
  storageAdjustmentReason: "/master/api/adjustment/getAdjustmentTypes/storage",
  storeAdjustmentReason: "/master/api/adjustment/getAdjustmentTypes/store",
  initiateTransactionChargebackManual:
    "/hil/transaction/api/transaction/ui/dispute/refund/manual/for",
  initiateTransactionRefundManual:
    "/hil/transaction/api/transaction/ui/dispute/chargeback/manual/for/",

  /**
   * @ STOCK REPORT
   */
  getProductStockReportAdjustmentsExcel:
    "/inventory/api/inventory/report/export",
  getProductStockReportAdjustmentsKPI:
    "/product/api/products/getProductAdjustments",
  getProductStockReportAdjustments: "/inventory/api/inventory/report",

  /**
   * @ Tenant
   */
  getTenantIdByName: "/tenant/api/tenant/getTenantIdByName",
  createBusinessUser: "/tenant/api/tenant/createBusinessUser",
  updateBusinessUser: "/tenant/api/tenant/updateBusinessUser",
  getBusinessUsers: "/tenant/api/tenant/getBusinessUsers",
  getAdminUsers: "/tenant/api/tenant/getAdminUsers",
  createTenantUser: "/tenant/api/tenant/createTenantwithAdmin",
  getTenantDetailWithAdmin: "/tenant/api/tenant/getTenantDetailWithAdmin",
  getBusinessUserbyId: "/tenant/api/tenant/getBusinessUserbyId",
  deleteBusinessUser: "/tenant/api/tenant/deleteBusinessUser",
  updateTenantDetail: "/tenant/api/tenant/updateTenantDetail",
  getTenantsUsers: "/tenant/api/tenant/getTenants",
  updateTenantAddress: "/tenant/api/tenant/updateTenantAddress",
  getRolePermissionDetail: "/tenant/api/roles/getRolePermissionDetail",
  generatePhoneNumberOTP: "/tenant/api/tenant/generatePhoneNumberOTP",
  verifyPhoneNumberOTP: "/tenant/api/tenant/verifyPhoneNumberOTP",
  getTenantDashBoard: "/tenant/api/tenant/getTenantforDashboard",
  getThemesList: "/tenant/api/tenant/getThemes",
  createTheme: "/tenant/api/tenant/createTheme",
  getLogoDetail: "/tenant/api/tenant/getLogoDetail",
  getUserDetail: "/tenant/api/tenant/getUserDetail",

  /**
   * @ Sun SAAS
   */
  getAdminUserbyId: "/tenant/api/tenant/getAdminUserbyId",
  updateAdminUser: "/tenant/api/tenant/updateAdminUser",
  createAdminUser: "/tenant/api/tenant/createAdminUser",
  deleteAdminUser: "/tenant/api/tenant/deleteAdminUser",

  /**
   * @ RealM
   */
  createRealmwithAdmin: "/tenant/api/tenant/createRealmwithAdmin",
  updateRealmDetail: "/tenant/api/tenant/updateRealmDetail",
  getTenantRealms: "/tenant/api/tenant/getTenantRealms",
  getRealmDetailWithAdmin: "/tenant/api/tenant/getRealmDetailWithAdmin",

  /**
   * @ Tax Serivice
   */
  getTaxProviders: "/tax/api/tax/provider/getTaxProviders",
  saveTaxProvider: "/tax/api/tax/provider/saveTaxProvider",
  getTaxProviderById: "/tax/api/tax/provider/getTaxProviderById",
  testConnection: "/tax/api/tax/ping",

  /**
   * @ Roles Serice
   */
  updateRolePermissionList: "/tenant/api/roles/updateRolePermission",
  updateRoleAttributesByTenantId:
    "/tenant/api/roles/updateRoleAttributesByTenantId",
  getRoles: "/tenant/api/roles/getRoles",
  getRoleAttributesByTenantId: "/tenant/api/roles/getRoleAttributesByTenantId",
  getSassAdminRoles: "/tenant/api/roles/getRolesDetailByRolename",
  getTenantRoles: "/tenant/api/roles/getTenantRoles",
  createTenantRole: "/tenant/api/roles/createTenantRole",
  updateTenantRole: "/tenant/api/roles/updateTenantRole",
  deleteTenantRole: "/tenant/api/roles/deleteTenantRole",
  getTenantRoleDetailByRoleId: "/tenant/api/roles/getTenantRoleDetailByRoleId",
  getDefaultRoleDetail: "/tenant/api/roles/getDefaultRoleDetail",
  updateTenantRoleAttributes: "/tenant/api/roles/updateTenantRoleAttributes",
  updateDefaultRoleAttributes: "/tenant/api/roles/updateDefaultRoleAttributes",
  getTenantUserRoles: "/tenant/api/roles/getTenantUserRoles",
  getAdminUserRoles: "/tenant/api/roles/getAdminUserRoles",

  getAdminRoles: "/tenant/api/roles/getAdminRoles",
  createAdminRole: "/tenant/api/roles/createAdminRole",
  updateAdminRole: "/tenant/api/roles/updateAdminRole",
  deleteAdminRole: "/tenant/api/roles/deleteAdminRole",
  getAdminRoleDetailByRoleId: "/tenant/api/roles/getAdminRoleDetailByRoleId",
  updateAdminRoleAttributes: "/tenant/api/roles/updateAdminRoleAttributes",

  // SubSaaS Role Permission Attributes
  getSubsaasAdminRoleAttributes:
    "/usermanagement/api/usermanagement/subsaas/admin/role/attributes",
  updateSubsaasAdminRoleAttributes:
    "/usermanagement/api/usermanagement/update/subsaas/admin/attributes",

  // Tenant Role Permission Attributes
  getTenantAdminRoleAttributes:
    "/usermanagement/api/usermanagement/tenant/admin/role/attributes",
  updateTenantAdminRoleAttributes:
    "/usermanagement/api/usermanagement/update/tenant/admin/attributes",

  /**
   * @ SDC Module
   */
  getTurnstiles: "/sdc/api/sdc/getturnstiledetails",
  getCameras: "/sdc/api/sdc/getcameradetails",
  getEdgeDeviceHealth: "/sdc/api/sdc/getedgehealth",
  listplanogram: "/sdc/api/sdc/listplanogram",
  listSmartCoolerLive: "/gondola/api/coolerhealth",
  listSmartCoolerLiveSocket: "/progressws/ws/cooler-health",
  listStoreListLiveSocket: "/employeews/store/dashboard/ws",

  liveMonitoringDeviceDetailsLiveSocket:
    "/websocket/api/live/monitoring/ws/details",
  liveMonitoringStoreStatusLiveSocket:
    "/websocket/api/live/monitoring/ws/store/status",

  getProductCamera: "/sdc/api/sdc/getproductcamera",
  getGondolas: "/gondola/api/gondola/getgondoladetails",
  getGondolaById: "/gondola/api/gondola/getgondola?",
  getFSCamera: "/api/kc/getposdetails",
  getFSEdgeDevice: "/api/kc/getedgedevicedetails",
  listPlanogramFS: "/api/kc/listplanogram",
  getProductMap: "/smart/api/smartshelf/getproduct",
  getRetailersList: "",
  searchEmployeeActivities:
    "/transaction/api/employee/searchEmployeeActivities",
  getTenantLogmodules: "/auditlog/api/auditlog/getTenantLogmodules",
  getSassLogModules: "/auditlog/api/auditlog/getSassLogModules",
  getTenantAuditLogs: "/auditlog/api/auditlog/getTenantAuditLogs",
  getSassAuditLogs: "/auditlog/api/auditlog/getSassAuditLogs",
  getTenantAuditLogById: "/auditlog/api/auditlog/getTenantAuditLogById",
  getSassAuditLogById: "/auditlog/api/auditlog/getSassAuditLogById",
  getApplicationLogs: "/logquery/api/logquerier/getLogData",

  /**
   * @ Alerts
   */
  createAlertConfig: "/alert/api/alerts/createAlertConfig",
  getalertconfigurationlist: "/alert/api/alerts/getAlertConfigurationList",
  getTenantAlertConfiglist: "/alert/api/alerts/getTenantAlertConfigList",
  updateAlertConfig: "/alert/api/alerts/updateAlertConfig",
  deleteAlertConfig: "/alert/alerts/management/alert/delete",
  updateAlertMonitor: "/alert/api/alerts/updateAlertMonitor",

  /**
   * @ Payment Configuration
   */
  createPaymentConfig: "/paymentwrapper/api/payment/config/create",
  updatePaymentConfigStatus:
    "/payment/api/paymentConfig/updatePaymentConfigStatus",
  getPaymentConfig: "/paymentwrapper/api/payment/config/all",
  deletePaymentConfig: "/payment/api/paymentConfig/deletePaymentConfig",
  deletePaymentWrapperConfig:
    "/paymentwrapper/api/payment/config/delete/by/id?is_realm=false",
  paymentTestConnection: (paymentProvider) => {
    return `/paymentwrapper/api/payment/${paymentProvider}/test/connection`
  },
  getDefaultCountrySelected: (defaultCountryCodeSelected) => {
    const country =
      defaultCountryCodeSelected ||
      (typeof localStorage !== "undefined"
        ? localStorage.getItem("country_code")
        : "") ||
      "US"
    return `/paymentwrapper/api/payment/config/get/payment/types/by/country?country=${country}`
  },
  getPaymentConfigByPaymentType:
    "/payment/api/paymentConfig/getPaymentConfigByPaymentType",
  getAllPaymentAccountName: "/paymentwrapper/api/payment/config/all",
  getPaymentMethodDropdown:
    "/paymentwrapper/api/payment/config/accountname/dropdown",
  /**
   * @ Alert setup
   */
  getNewAlertList: "/alert/definition/alert/all",
  getAlertSetupLevelAll: "/alert/definition/level/all",
  getAlertSetupEntityFilterByIds: "/alert/definition/entity/filter/by/ids",
  getAlertSetupSeverityAll: "/alert/definition/severity/all",
  getAlertScheduleAll: "/alert/management/schedule/all",
  createSetupAlert: "/alert/definition/alert/create",
  updateSetupAlert: "/alert/definition/alert/update",
  unconfiguredTenantAlertList: "/alert/definition/alert/unconfigured/by/tenant",
  deleteAlertFromHub: "/alert/definition/alert/delete/",

  /**
   * @ Configuration setup
   */
  configurationSave: "/alert/management/save/multiple",
  configurationTenantList: "/alert/management/all",
  configurationRoleSubscription: "/alert/management/role/by/subscription",
  configurationSubscriptionUpdate: "/alert/management/update",
  /**
   * @ Payment Type Service
   */
  getPaymentTypes: "/payment/api/paymentConfig/getPaymentTypes",
  getPaymentWrapperTypes:
    "/paymentwrapper/api/payment/config/get/payment/types",

  /**
   * @ Shelf Type Services
   */
  getShelfTypes: "/master/api/shelf/getShelfTypes",

  /**
   * @ monitoring Services
   */
  getAlertMonitorlist: "/alert/monitoring/all",
  alertMonitoringWSS: "/progressws/ws/alertMonitoring",
  monitoringUpdate: "/alert/monitoring/update",
  dashboardAlertRealm: "/alert/monitoring/count/by/realm",
  dashboardAlertTenant: "/alert/monitoring/count/by/tenant",
  dashboardAlertStore: "/alert/monitoring/count/by/location",
  dashboardAlertAll: "/alert/monitoring/count",
  getAlertTabDetails: "/alert/monitoring/count/by/status",

  /**
   * @ Vendor
   */
  vendorCreate: "/vendor/api/vendor/create",
  vendorLogo: "/vendor/api/vendor/logo/upload",
  vendorUpdate: "/vendor/api/vendor/update",
  getVendorDetail: "/vendor/api/vendor/by/id",
  vendorList: "/vendor/api/vendor/all",
  getVendorList: "/vendor/api/vendor/all/names/by/ids?is_active=true",
  deleteVendor: "/vendor/api/vendor/delete/many",

  /**
   * @ cycle Count
   */
  getProductCycleCounts: "/product/api/cyclecount/getProductCycleCounts",
  createProductCycleCount: "/product/api/cyclecount/createProductCycleCount",
  cycleCountExcelTemplate: "/import/api/export/sample/download",

  /**
   * @ Iventory Report
   */
  generateInventoryReport: "/report/api/report/inventory/file",
  generateInventoryLogReport: "/report/api/report/inventory/log/file",
  generateInventoryStoreListGrid: "/report/api/report/inventory/store/all",
  generateInventoryStorageListGrid: "/report/api/report/inventory/storage/all",
  generateSummaryTransactionReport:
    "/report/api/report/transaction/summary/store/all",
  generateDetailedTransactionReport:
    "/report/api/report/transaction/detail/store/all",
  generateDetailedTransactionReportDetail:
    "/report/api/report/transaction/summary/store/detail",
  getinventoryTransaction: "/report/api/report/inventory/Transaction",
  getinventoryTransactionExport:
    "/report/api/report/inventory/Transaction/export",

  /**
   * Live Monitoring API
   */
  DeviceLiveMonitoringTimeStamp:
    "/gondola/api/liveMonitor/store/device/timestamp",
  GondolaLiveMonitoringTimeStamp:
    "/gondola/api/liveMonitor/store/gondola/timestamp",
}
